import { Alert, Snackbar } from "@mui/material";
import React, { useState } from "react";

export const ErrorBar = ({ message, resetError }) => {
  const [open, setOpen] = useState(true);
  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={3000}
        onClose={() => {
          setOpen(false);
          resetError(false);
        }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};
